import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from "rxjs";
import { BylineInterface } from "../models/byline.interface";
import { UserDataService } from "../../user/services/user-data.service";
import { ApiService } from "@core/services/api.service";
import { ProfileService } from "./profile.service";

@Injectable({
    providedIn: 'root'
})
export class BylineService {
    currentUserBylines$ = new BehaviorSubject<BylineInterface[]>([{}] as BylineInterface[]);
    profileBylines$ = new BehaviorSubject<BylineInterface>({} as BylineInterface);
    allBylines$ = combineLatest(this.profileBylines$, this.currentUserBylines$)

    constructor(private userDataService: UserDataService, private api: ApiService, private profileService: ProfileService) {

        this.userDataService.currentUserData$.subscribe(
            data => {
                this.getUserBylines(data.user_id);
                this.getProfileBylines();
            }
        )
    }

    getUserBylines(userId: number | null) {
        if (userId) {
            this.api.getUserBylines(userId).subscribe((response: any) => {
                const bylines = response.bylines;
                this.currentUserBylines$.next(bylines);

            })
        }
    }

    getProfileBylines() {
        this.profileService.profiles$.subscribe((profiles: any) => {
            const bylines = profiles
                .filter((item: any) => {
                    return item.profile_name == this.userDataService.currentUserData$.getValue().profile
                })
                .map((item: any) => {
                    return { byline_id: null, content: item.byline, default: false }
                })
            this.profileBylines$.next(bylines);
        })

    }


}
